<template>
    <div class="text-center">
        <div class="spinner-border" role="status">
            <span class="sr-only">{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: ['text']
}
</script>